module.exports = __webpack_public_path__ + "media/images/emblems/GemeindewappenNiedergesteln_jpeg-4106df5b8d0e0a0c755ac8b1d2f39fe6.png";